export default __webpack_public_path__ + "static/media/quadroCores.2e98715e.png";